{
    "Profile_Summary_Recap.taxesIncluded": "FR: {estimatedAnnualGross} (taxes included)",
    "Profile_Summary_Recap.savings": "FR: You could save {estimatedAnnualPremium} annually ({estimatedMonthlyGross} monthly)",
    "Profile_Summary_Recap.downloadBinder": "FR: Download Binder"
}
